import React from "react";
import { useStore } from "../../../store/useStore";
import Title from "antd/lib/typography/Title";
import { Button, Form, Input, notification } from "antd";
import { changePassword } from "../../../store/actions";
import useStatefulForm from "../../../hooks/useStatefulForm";

const UpdatePasswordForm: React.FC = () => {
  const { form, isSubmitting, setSubmitting } = useStatefulForm();
  const { dispatch } = useStore();

  return (
    <>
      <Form
        form={form}
        name="password-update-form"
        className="flex flex-col"
        autoComplete="new-password"
        onFinish={async (values) => {
          try {
            setSubmitting(true);
            await dispatch(
              changePassword(values.oldPassword, values.newPassword)
            );
            notification.success({
              message: "Password updated!",
              placement: "bottomRight",
            });
            form.resetFields();
            setSubmitting(false);
          } catch (error) {
            switch (error.code) {
              case "LimitExceededException":
                notification.error({
                  message: "Too many failed attempts, please try again later",
                  placement: "bottomRight",
                });
                break;
              case "NotAuthorizedException":
                notification.error({
                  message: "Password is incorrect",
                  placement: "bottomRight",
                });
                break;
            }
            setSubmitting(false);
          }
        }}
      >
        <Form.Item
          name="oldPassword"
          rules={[
            {
              required: true,
              message: "Please input your current password",
            },
          ]}
        >
          <Input placeholder="Old password" type="password" />
        </Form.Item>
        <Form.Item
          name="newPassword"
          rules={[
            { required: true, message: "Please input your new password" },
          ]}
        >
          <Input.Password placeholder="New password" type="password" />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          rules={[
            {
              required: true,
              message: "Please confirm your new password",
            },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }

                return Promise.reject(
                  "The two passwords that you entered do not match"
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm password" type="password" />
        </Form.Item>

        <Form.Item className="flex flex-col">
          <div className="flex flex-col text-center">
            <Button type="primary" htmlType="submit" loading={isSubmitting}>
              Update password
            </Button>
          </div>
        </Form.Item>
      </Form>
    </>
  );
};

export default UpdatePasswordForm;
